import { Controller } from "@hotwired/stimulus"
import html2canvas from "html2canvas"

export default class extends Controller {
  static targets = ["element", "button", "wrapper"]
  static values = { filename: String }

  connect() {
    console.log("Export controller connected")
  }

  async download(event) {
    event.preventDefault()

    const btn = this.buttonTarget
    const element = this.elementTarget
    const wrapper = this.hasWrapperTarget ? this.wrapperTarget : null
    const originalHtml = btn.innerHTML

    try {
      btn.innerHTML = '<span class="loading loading-spinner loading-sm"></span>'
      btn.classList.add("disabled", "pointer-events-none")

      if (wrapper) {
        wrapper.style.position = "fixed"
        wrapper.style.left = "-9999px"
        wrapper.style.top = "0"
        wrapper.style.display = "block"
      }

      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)))

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#0f172a",
      })

      if (wrapper) wrapper.style.display = "none"

      const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"))
      if (!blob) throw new Error("PNG blob creation failed")

      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.download = this.filenameValue || "export.png"
      link.href = url
      link.style.display = "none"
      document.body.appendChild(link)
      link.click()
      link.remove()
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Export error:", error)
      if (wrapper) wrapper.style.display = "none"
      btn.textContent = "Error: " + error.message
      btn.classList.add("btn-error")
      btn.classList.remove("btn-primary")
      setTimeout(() => {
        btn.innerHTML = originalHtml
        btn.classList.remove("btn-error")
        btn.classList.add("btn-primary")
      }, 4000)
    } finally {
      btn.classList.remove("disabled", "pointer-events-none")
    }
  }
}